// Price Box landmine tooltip — the WORDING behind a coloured header (CR-20260904-001, Presentation,
// follow-on 2026-09-08, owner rulings O70–O72).
//
// One question, one answer: given the events behind a day's verdict, what does the hover tooltip
// list? Two groups, "Reports" and "Earnings"; a report is named by its kind only (the date is already
// in the header the trader is hovering), an earnings entry by its ticker only. A group with nothing
// in it is omitted. Every event on the verdict is listed, Tier 1 and Tier 2 together (O72).
//
// Presentation only, pure, Angular-free. Reads the events for WORDING only — never re-derives a
// tier from them (the model's own rule on `LandmineDay.events`).
// ES5 note: arrays + indexOf only (no Set / for..of), matching the rest of the copilot logic.

import {LandmineEvent} from '../services/landmine-day.model';

export interface LandmineTooltipContent {
    /** Report kinds, e.g. 'CPI', 'FOMC', 'NFP' — in verdict order, de-duplicated. */
    reports: string[];
    /** Earnings tickers, e.g. 'NVDA' — in verdict order, de-duplicated. */
    earnings: string[];
}

/**
 * Groups a verdict's events into the two tooltip lists. Returns null when there is nothing to say
 * (no events, or only events without a usable name), so the caller can skip the tooltip entirely.
 */
export function buildLandmineTooltip(events: LandmineEvent[] | null | undefined): LandmineTooltipContent | null {

    const reports: string[] = [];
    const earnings: string[] = [];

    const list = events || [];
    for (let i = 0; i < list.length; i++) {
        const ev = list[i];
        if (!ev) {
            continue;
        }

        if (ev.kind === 'Earnings') {
            const ticker = ev.ticker ? ev.ticker : null;
            if (ticker && earnings.indexOf(ticker) < 0) {
                earnings.push(ticker);
            }
            continue;
        }

        if (ev.kind && reports.indexOf(ev.kind) < 0) {
            reports.push(ev.kind);
        }
    }

    if (reports.length === 0 && earnings.length === 0) {
        return null;
    }

    return {reports, earnings};
}
